import {createSlice} from '@reduxjs/toolkit';
import {resendEmailCodeApi} from "../../api/auth/resendEmailCodeApi";

export const resendEmailCodeSlice = createSlice({
    name: 'users',
    initialState: {
        entities: [],
        loading: 'idle',
        currentRequestId: undefined,
        errorMessage: '',
        errors: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(resendEmailCodeApi.pending, (state, action) => {
                const { requestId } = action.meta
                if (state.loading === 'idle') {
                    state.loading = 'pending'
                    state.currentRequestId === requestId
                }
            })
            .addCase(resendEmailCodeApi.fulfilled, (state, action) => {
                const {meta, payload} = action;
                const { requestId } = meta
                if (
                    state.loading === 'pending' &&
                    state.currentRequestId === requestId
                ) {
                    state.loading = 'fulfilled'
                    // @ts-ignore
                    state.entities.push(payload)
                    state.currentRequestId = undefined
                }
            })
            .addCase(resendEmailCodeApi.rejected, (state, action) => {
                state.loading = 'rejected'
            })
    },
});


export default resendEmailCodeSlice.reducer;